import { schema } from 'normalizr';
import { MentoringProgramActionItemTemplate } from '../models/mentoring-program-action-item-templates';

export const MentorshipProgramActionItemTemplateSchema = new schema.Entity<MentoringProgramActionItemTemplate>('mentorshipProgramActionItemTemplates');

export const MentorshipProgramActionItemTemplatesSchema = new schema.Array(MentorshipProgramActionItemTemplateSchema);
